import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { usePersonalLoanPrequalResultState } from 'partial/OfferManager/modules/PersonalLoanPrequalResultModule/hooks/PersonalLoanPrequalResultModule.hook';
import { PL_PREQUAL_RESULT_KEY } from 'actions/datacache.actions';
import { selectForKey, cachePayloadForKey } from 'actions/datacache.actions';
import { retrievePrequalFormData } from '../PersonalLoanMarketplaceModule.actions';
import { setStaticModuleOfMarketplaceOffer } from 'actions/offers.actions';

export const getPartnerForUnifiedExperience = () => {
  return 'ALL';
};

export const usePlPrequalFormData = props => {
  const { prequalResultData, prequalResultDataLoading, userInfo } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (
      (!prequalResultData ||
        (!prequalResultData.isEmptyForm && !prequalResultData.formInput)) &&
      !prequalResultDataLoading &&
      userInfo
    ) {
      getPrequalFormData();
    } else {
      setLoading(false);
    }
    //eslint-disable-next-line
  }, [userInfo]);

  const getPrequalFormData = () => {
    dispatch(retrievePrequalFormData()).finally(() => {
      setLoading(false);
    });
  };
  return {
    loading,
  };
};

export const usePlMarketplacePrequalState = props => {
  const { userInfo, dispatch } = props;

  const [prequalResultData, prequalResultDataLoading, prequalResultDataError] =
    useSelector(state => selectForKey(PL_PREQUAL_RESULT_KEY, state));
  const prequalFormMetadata = usePlPrequalFormData({
    prequalResultData,
    prequalResultDataLoading,
    prequalResultDataError,
    userInfo,
  });
  const showPrequalTopModule =
    !prequalFormMetadata.loading &&
    (!prequalResultData || !prequalResultData.formInput);

  const prequalResultMetadata = usePersonalLoanPrequalResultState(
    userInfo,
    prequalFormMetadata.loading,
  );
  const loading = prequalResultMetadata.loading;
  //eslint-disable-next-line
  const [fromPrequalResult, setFromPrequalResult] = useState(
    prequalResultData ? prequalResultData.fromPrequalResult : false,
  );

  //init
  useEffect(() => {
    if (prequalResultMetadata.hasOffers && !fromPrequalResult) {
      prequalResultData.fromPrequalForm = false;
      dispatch(cachePayloadForKey(PL_PREQUAL_RESULT_KEY, prequalResultData));
      dispatch(
        setStaticModuleOfMarketplaceOffer('PERSONAL_LOAN_PREQUAL_RESULTS'),
      );
    }
    //eslint-disable-next-line
  }, [prequalResultMetadata.hasOffers]);

  //reset fromPrequalResult flag
  useEffect(() => {
    if (prequalResultData) {
      prequalResultData.fromPrequalResult = false;
      dispatch(cachePayloadForKey(PL_PREQUAL_RESULT_KEY, prequalResultData));
    }
    //eslint-disable-next-line
  }, [prequalResultData]);

  return Object.assign(prequalResultMetadata, {
    plPrequalLoading: loading,
    showPrequalTopModule,
  });
};
